export async function assessmentWorkbook(data) {
  const { default: ExcelJS } = await import("exceljs/dist/exceljs.min.js");
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sent Assessments");
  sheet.columns = ["Name", "ID", "Level", "Score"].map(key => ({ header: key, key }));
  sheet.addRows(data);
  return workbook.xlsx.writeBuffer();
}

export async function exportAssessments(data, testId) {
  const buffer = await assessmentWorkbook(data);
  const url = URL.createObjectURL(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `SentAssessments-${testId || "All"}.xlsx`;
  document.body.appendChild(link);
  try { link.click(); }
  finally { link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000); }
}
